import api from "../api";
import { API_URL } from "../constants";

export const getCurrentUser = async () => {
  return api.get(`${API_URL}/v1/user/me`);
};

export const completeOnboarding = async () => {
  return api.post(`${API_URL}/v1/user/me/onboarding-complete`);
};
